var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6318_205296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 88,
    height: 88
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 48C4 23.6 23.6 4 48 4C72.4 4 92 23.6 92 48C92 72.4 72.4 92 48 92C23.6 92 4 72.4 4 48ZM12 48C12 68 28 84 48 84C68 84 84 68 84 48C84 28 68 12 48 12C28 12 12 28 12 48ZM52 48V64C52 66.4 50.4 68 48 68C45.6 68 44 66.4 44 64V48C44 45.6 45.6 44 48 44C50.4 44 52 45.6 52 48ZM52 32C52 30.8 51.6 30 50.8 29.2C50 28.4 48.4 28 47.2 28C46.97 28.23 46.8722 28.3278 46.7546 28.3693C46.6677 28.4 46.57 28.4 46.4 28.4C46.2 28.4 46.1 28.5 46 28.6C45.9 28.7 45.8 28.8 45.6 28.8L45.2 29.2C44.4 30 44 30.8 44 32C44 33.2 44.4 34 45.2 34.8C45.2 34.8 45.2 35.2 45.6 35.2C45.8 35.2 45.9 35.3 46 35.4C46.1 35.5 46.2 35.6 46.4 35.6C46.63 35.83 46.7278 35.9278 46.8454 35.9693C46.9323 36 47.03 36 47.2 36H48C49.2 36 50 35.6 50.8 34.8C51.6 34 52 33.2 52 32Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6318_205296)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6318_205296)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#2FA5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    stroke: "black",
    strokeOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6318_205296",
    x: -4.5,
    y: -0.5,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6318_205296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6318_205296",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.24d232438c2c96d511ce82af4bd3a930.svg";
export { ForwardRef as ReactComponent };